import axios from 'axios'
import authHeader from './AuthHeader'
import { API_URL } from '../config/api'

class MyProfileService {

  getMyProfile = async () => {    
    return await axios.get(API_URL + '/myprofile', { headers: authHeader() }); // Pasa los headers como segundo argumento
  }
  
  updateMyProfile = async (user) => {
    return await axios.patch(API_URL + '/myprofile', user, { headers: authHeader() }); // Segundo argumento es el body
  }

}

export default new MyProfileService()